import GeneralCard from '../../../general/GeneralCard';
import ExposureBarChart from './ExposureBarChart';
import { useWindowSize } from '../../../../hooks/useWindowSize';
import { FC } from 'react';

export interface CountryCodeGrossExposureProps {
  data: FundExposureData;
  isFetching: boolean;
}

const AmlLevelGrossExposure: FC<CountryCodeGrossExposureProps> = ({
  data,
  isFetching,
}) => {
  const { width, height } = useWindowSize();
  return (
    <GeneralCard cardStyle={{ flexGrow: 1 }}>
      <ExposureBarChart
        windowWidth={width}
        windowHeight={height}
        isFetching={isFetching}
        inputData={data}
        exposureType="amlLevel"
        exportButton
      />
    </GeneralCard>
  );
};

export default AmlLevelGrossExposure;
